export default __webpack_public_path__ + "static/media/screen-header.cfc132c1.svg";